import AppleHealthChartsWrapper from 'pages/Dashboard/components/AppleHealthChartsWrapper';
import React, { useEffect } from 'react';
import AppleHealthActivityChart from 'pages/Dashboard/components/AppleHealthActivityChart';
import useActivityData from 'pages/Dashboard/useActivityData';
import AppleHealthActivitySummaryChart, { DataKey } from 'pages/Dashboard/components/AppleHealthActivitySummaryChart';
import { TimeFrameOptions, waypointBarSizeMap } from 'pages/Dashboard/utils/trackingUtils';

interface ActivityComponentProps {
    timeFrame: TimeFrameOptions;
    waypointId:string;
    patientId:string;
    providerId:string;
    type:string;
    setCardStatus?: (type:string, v: boolean) => void;
    numberOfCards:number;
    setLoading?: (value:boolean) => void

   }

function ActivityComponent({
  patientId,
  providerId,
  waypointId,
  timeFrame,
  setCardStatus,
  type,
  numberOfCards,
  setLoading,
} : ActivityComponentProps) {
  const {
    appleHealthActivityData,
    appleHealthActivityGoals,
    appleHealthActivityAverageData,
    appleHealthActivityPreviousPeriodAverageData,
    appleHealthActivityAvgData,
    sourceOptions,
    sourceId,
    onChangeSource,
    yAxisProps,
    hasStandHours,
    sourceObject,
    isLoading,
    has6MonthsData,
  } = useActivityData({
    patientId,
    providerId,
    waypointId,
    timeFrame,
  });
  useEffect(() => {
    setCardStatus && setCardStatus(type, has6MonthsData);
  }, [has6MonthsData, setCardStatus, type]);
  const getActivityTitle = hasStandHours ? 'Activity' : 'Active Energy Burned';
  useEffect(() => {
    setLoading?.(isLoading);
  }, [isLoading, setLoading]);
  const activityTitle = sourceObject?.sourcePlatform === 'android'
    ? 'Total Calories Burned' : getActivityTitle;
  const activitySubtitle = sourceObject?.sourcePlatform === 'android' ? 'active + resting' : '';
  const activityDataKey = sourceObject?.sourcePlatform === 'ios' ? DataKey.ActiveEnergyBurned : DataKey.TotalCaloriesBurned;
  return has6MonthsData ? (
    <>
      {hasStandHours && (
        <AppleHealthChartsWrapper
          timeFrame={timeFrame}
          title={activityTitle}
          subTitle={activitySubtitle}
          headerIcon='snowshoeing'
          gridSize={numberOfCards === 3 ? 4 : 6}
          isLoading={isLoading}
          hasMultipleItems
          showTimeFrame
          sourceObject={sourceObject}
          renderChart={(
            <AppleHealthActivityChart
              chartData={appleHealthActivityData}
              chartGoals={appleHealthActivityGoals}
              yAxisProps={yAxisProps}
              barSize={waypointBarSizeMap[`${timeFrame}-${4}`]}
              averages={appleHealthActivityAverageData}
              previousPeriodAverages={appleHealthActivityPreviousPeriodAverageData}
              timeFrame={timeFrame}

            />
          )}
        />
      )}
      {!hasStandHours && (
        <AppleHealthChartsWrapper
          timeFrame={timeFrame}
          title={activityTitle}
          subTitle={activitySubtitle}
          gridSize={numberOfCards === 3 ? 4 : 6}
          headerIcon='snowshoeing'
          hasMultipleItems
          showTimeFrame
          sourceObject={sourceObject}
          isLoading={isLoading}
          renderChart={(
            <AppleHealthActivitySummaryChart
              chartData={appleHealthActivityData}
              dataKey={activityDataKey}
              units='kCal'
              average={appleHealthActivityAvgData}
              yAxisProps={yAxisProps}
              yAxisDefinition='Calories'
              barSize={waypointBarSizeMap[`${timeFrame}-${4}`]}
              sourceId={sourceId}
              sourceOptions={sourceOptions}
              setSourceId={onChangeSource}

            />
          )}
        />
      )}
    </>

  ) : null;
}

export default ActivityComponent;
